
import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { useInView } from 'react-intersection-observer';
import styles from './ProfitsGraph.module.css';

const ProfitsGraph = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.3,
    rootMargin: "-50px"
  });

  const data = [
    {date: '20 Apr', profit: 136.06}, {date: '21 Apr', profit: 286.06}, {date: '22 Apr', profit: 256.06},
    {date: '23 Apr', profit: 445.56}, {date: '24 Apr', profit: 430.82}, {date: '25 Apr', profit: 815.07},
    {date: '26 Apr', profit: 564.24}, {date: '27 Apr', profit: 1074.46}, {date: '28 Apr', profit: 1097.96},
    {date: '29 Apr', profit: 1135.46}, {date: '30 Apr', profit: 1310.85}, {date: '1 May', profit: 1307.85},
    {date: '2 May', profit: 1377.85}, {date: '3 May', profit: 1594.34}, {date: '4 May', profit: 1999.34},
    {date: '5 May', profit: 2210.67}, {date: '6 May', profit: 2265.67}, {date: '7 May', profit: 2170.67},
    {date: '8 May', profit: 2148.67}, {date: '9 May', profit: 2299.92}, {date: '10 May', profit: 2148.92},
    {date: '11 May', profit: 2293.92}, {date: '12 May', profit: 2363.92}, {date: '13 May', profit: 2368.92},
    {date: '14 May', profit: 2318.92}, {date: '15 May', profit: 2306.42}, {date: '16 May', profit: 2656.92},
    {date: '17 May', profit: 2650.67}, {date: '18 May', profit: 2889.63}, {date: '19 May', profit: 2907.81},
    {date: '23 May', profit: 2972.81}, {date: '24 May', profit: 3015.31}, {date: '25 May', profit: 3192.78},
    {date: '26 May', profit: 3372.78}, {date: '28 May', profit: 3452.78}, {date: '29 May', profit: 3412.78},
    {date: '30 May', profit: 3582.77}, {date: '31 May', profit: 3897.77}, {date: '1 Jun', profit: 4052.78},
    {date: '2 Jun', profit: 3940.28}, {date: '5 Jun', profit: 4425.27}, {date: '6 Jun', profit: 4410.27},
    {date: '7 Jun', profit: 4515.27}, {date: '8 Jun', profit: 4567.77}, {date: '9 Jun', profit: 4752.77},
    {date: '10 Jun', profit: 4571.10}, {date: '13 Jun', profit: 4884.10}, {date: '14 Jun', profit: 5385.35},
    {date: '15 Jun', profit: 5597.85}, {date: '16 Jun', profit: 5697.85}, {date: '17 Jun', profit: 5567.85},
    {date: '18 Jun', profit: 5487.85}, {date: '19 Jun', profit: 5407.85}, {date: '20 Jun', profit: 5543.85},
    {date: '21 Jun', profit: 5748.85}, {date: '22 Jun', profit: 5572.85}, {date: '23 Jun', profit: 5492.85},
    {date: '24 Jun', profit: 5342.85}, {date: '26 Jun', profit: 5836.35}, {date: '27 Jun', profit: 5636.35},
    {date: '28 Jun', profit: 5621.35}, {date: '29 Jun', profit: 5625.15}, {date: '30 Jun', profit: 5713.15},
    {date: '4 Jul', profit: 5748.15}, {date: '5 Jul', profit: 5918.15}, {date: '6 Jul', profit: 5933.15},
    {date: '7 Jul', profit: 6003.15}, {date: '10 Jul', profit: 6173.15}, {date: '11 Jul', profit: 6043.15},
    {date: '12 Jul', profit: 6363.65}, {date: '13 Jul', profit: 6444.14}, {date: '14 Jul', profit: 6560.64},
    {date: '15 Jul', profit: 6560.64}, {date: '17 Jul', profit: 6015.64}, {date: '18 Jul', profit: 6150.64},
    {date: '19 Jul', profit: 6203.14}, {date: '20 Jul', profit: 5933.14}, {date: '21 Jul', profit: 5708.14},
    {date: '24 Jul', profit: 5628.14}, {date: '25 Jul', profit: 5548.14}, {date: '27 Jul', profit: 5553.14},
    {date: '28 Jul', profit: 5444.81}, {date: '31 Jul', profit: 5797.31}, {date: '1 Aug', profit: 5692.31},
    {date: '2 Aug', profit: 5588.31}, {date: '3 Aug', profit: 5742.81}, {date: '4 Aug', profit: 5919.81},
    {date: '6 Aug', profit: 6122.81}, {date: '8 Aug', profit: 6237.81}, {date: '9 Aug', profit: 6247.81},
    {date: '10 Aug', profit: 6342.81}, {date: '14 Aug', profit: 6327.81}, {date: '15 Aug', profit: 6272.81},
    {date: '16 Aug', profit: 6052.81}, {date: '17 Aug', profit: 6117.81}, {date: '18 Aug', profit: 6102.81},
    {date: '22 Aug', profit: 6138.81}, {date: '23 Aug', profit: 6438.81}, {date: '24 Aug', profit: 6638.81},
    {date: '25 Aug', profit: 6813.81}, {date: '27 Aug', profit: 6783.81}, {date: '29 Aug', profit: 6688.81},
    {date: '31 Aug', profit: 7316.31}, {date: '1 Sep', profit: 7310.31}, {date: '4 Sep', profit: 7280.31},
    {date: '5 Sep', profit: 7315.31}, {date: '6 Sep', profit: 7315.31}, {date: '7 Sep', profit: 7500.30},
    {date: '8 Sep', profit: 7400.30}, {date: '9 Sep', profit: 7385.30}, {date: '10 Sep', profit: 7305.30},
    {date: '12 Sep', profit: 7275.30}, {date: '13 Sep', profit: 7165.30}, {date: '14 Sep', profit: 7571.30},
    {date: '16 Sep', profit: 7556.30}, {date: '17 Sep', profit: 8101.30}, {date: '18 Sep', profit: 8086.30},
    {date: '19 Sep', profit: 8201.30}, {date: '20 Sep', profit: 8371.30}, {date: '21 Sep', profit: 8536.30},
    {date: '22 Sep', profit: 8608.80}, {date: '26 Sep', profit: 8593.80}, {date: '27 Sep', profit: 8558.80},
    {date: '28 Sep', profit: 8363.80}, {date: '29 Sep', profit: 8203.80}, {date: '30 Sep', profit: 8188.80},
    {date: '2 Oct', profit: 8208.80}, {date: '3 Oct', profit: 8193.80}, {date: '4 Oct', profit: 7996.30},
    {date: '5 Oct', profit: 7996.30}, {date: '6 Oct', profit: 7996.30}, {date: '7 Oct', profit: 7921.30},
    {date: '8 Oct', profit: 7841.30}, {date: '10 Oct', profit: 8188.80}, {date: '12 Oct', profit: 8090.30},
    {date: '13 Oct', profit: 8075.30}, {date: '14 Oct', profit: 8175.30}, {date: '17 Oct', profit: 8160.30},
    {date: '21 Oct', profit: 8145.30}, {date: '22 Oct', profit: 8020.30}, {date: '26 Oct', profit: 8100.30},
    {date: '28 Oct', profit: 8070.30}, {date: '31 Oct', profit: 7960.30}, {date: '2 Nov', profit: 7860.30},
    {date: '3 Nov', profit: 7795.30}, {date: '4 Nov', profit: 7780.30}, {date: '5 Nov', profit: 7755.30},
    {date: '7 Nov', profit: 7845.30}, {date: '8 Nov', profit: 7925.30}, {date: '9 Nov', profit: 8085.30},
    {date: '10 Nov', profit: 8155.30}, {date: '11 Nov', profit: 8225.30}, {date: '13 Nov', profit: 8437.80},
    {date: '14 Nov', profit: 8422.80}, {date: '16 Nov', profit: 8322.80}, {date: '17 Nov', profit: 8472.80},
    {date: '18 Nov', profit: 8553.80}, {date: '20 Nov', profit: 8538.80}, {date: '21 Nov', profit: 8628.80},
    {date: '23 Nov', profit: 8608.80}, {date: '24 Nov', profit: 8641.30}, {date: '25 Nov', profit: 8683.80},
    {date: '26 Nov', profit: 8868.80}, {date: '27 Nov', profit: 9443.80}, {date: '28 Nov', profit: 10288.80},
    {date: '29 Nov', profit: 10113.80}, {date: '30 Nov', profit: 10093.80}, {date: '1 Dec', profit: 10018.80},
    {date: '2 Dec', profit: 10028.80}, {date: '3 Dec', profit: 9978.80}, {date: '4 Dec', profit: 10058.80},
    {date: '5 Dec', profit: 9971.30}, {date: '6 Dec', profit: 10071.30}, {date: '7 Dec', profit: 10566.30},
    {date: '8 Dec', profit: 10263.80}, {date: '9 Dec', profit: 10443.80}, {date: '10 Dec', profit: 10415.30},
    {date: '11 Dec', profit: 10357.80}, {date: '12 Dec', profit: 10212.80}, {date: '13 Dec', profit: 10217.80},
    {date: '14 Dec', profit: 9905.30}, {date: '15 Dec', profit: 9714.30}, {date: '16 Dec', profit: 9954.30},
    {date: '17 Dec', profit: 10194.30}, {date: '18 Dec', profit: 10007.80}, {date: '19 Dec', profit: 10007.80},
    {date: '20 Dec', profit: 10142.80}, {date: '21 Dec', profit: 10695.30}, {date: '22 Dec', profit: 10659.55},
    {date: '23 Dec', profit: 10404.55}, {date: '24 Dec', profit: 10309.55}, {date: '26 Dec', profit: 10677.05},
    {date: '27 Dec', profit: 10597.05}, {date: '28 Dec', profit: 10732.05}, {date: '29 Dec', profit: 10657.05},
    {date: '30 Dec', profit: 10559.55}, {date: '31 Dec', profit: 10622.05}
  ];

  return (
    <div ref={ref} className={`${styles.container} ${inView ? 'animate-in' : ''}`}>
      <h2 className={styles.title}>How our Matched Betting System has Performed</h2>
      <p className={styles.lastUpdated}>Last updated: 31 Dec 2024</p>
      <div className={styles.graphWrapper}>
        <ResponsiveContainer width="100%" height={500}>
          <LineChart data={data} margin={{ top: 20, right: 30, left: 20, bottom: 50 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.1)" />
            <XAxis 
              dataKey="date" 
              angle={-45} 
              textAnchor="end" 
              interval={15}
              stroke="#fff"
              tick={{ fill: '#fff', fontSize: 12 }}
            />
            <YAxis 
              tickFormatter={(value) => `$${value.toLocaleString()}`}
              domain={[0, 'dataMax + 1000']}
              stroke="#fff"
              tick={{ fill: '#fff', fontSize: 12 }}
            />
            <Tooltip 
              formatter={(value) => [`$${value.toLocaleString()}`, 'Profit']}
              contentStyle={{ 
                backgroundColor: 'rgba(0,0,0,0.8)', 
                border: '1px solid #666',
                borderRadius: '4px'
              }}
              labelStyle={{ color: '#fff' }}
            />
            <Line 
              type="monotone" 
              dataKey="profit" 
              stroke="#6568f4"
              strokeWidth={3}
              dot={false}
              activeDot={{ r: 8, fill: '#6568f4' }}
              strokeDasharray="3000"
              strokeDashoffset={inView ? "0" : "3000"}
              style={{
                transition: "stroke-dashoffset 2.5s ease-in-out"
              }}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}

export default ProfitsGraph;
